import { render, staticRenderFns } from "./data48.vue?vue&type=template&id=0bcbd29e&scoped=true"
import script from "./data48.vue?vue&type=script&lang=js"
export * from "./data48.vue?vue&type=script&lang=js"
import style1 from "./data48.vue?vue&type=style&index=1&id=0bcbd29e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcbd29e",
  null
  
)

export default component.exports